import React, { useEffect, useRef, useState } from 'react';
import { Alert, Spinner } from 'react-bootstrap';
import { Link, useHistory, useLocation } from 'react-router-dom';
import apiService from '../services/api.service';
import { appPath, rememberAppSlug } from '../utils/appSlug';
import { decodeAccessToken } from '../utils/session';
import { tenantSessionAllowed } from '../utils/tenant';
import './login.css';

export default function EventAccess({ appSlug, setLoginStatus }) {
  const location = useLocation();
  const history = useHistory();
  const [token] = useState(() => new URLSearchParams(location.hash.replace(/^#/, '')).get('token'));
  const [error, setError] = useState('');
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    // Remove the personal secret before starting any asynchronous work.
    history.replace({ pathname: location.pathname, search: '', hash: '' });
    if (!token || token.length > 512) {
      setError('Il link di accesso non è valido. Richiedi un nuovo invito al gestore.');
      return;
    }
    let active = true;
    async function redeem() {
      try {
        const { data } = await apiService.redeemEventAccess(appSlug, token);
        if (!active) return;
        const identity = decodeAccessToken(data?.access_token);
        if (!identity?.sub || !Number.isInteger(identity.uid) || typeof identity.pv !== 'string' ||
            identity.platform_role !== 'utente_base' || identity.is_verified !== true ||
            !Number.isFinite(identity.exp) || identity.exp * 1000 <= Date.now() ||
            data.application_slug !== appSlug || !tenantSessionAllowed(identity, { slug: appSlug }) ||
            !Number.isInteger(data.event_id) || data.event_id <= 0) {
          throw new Error('Invalid access response');
        }
        localStorage.setItem('user', JSON.stringify({ access_token: data.access_token, token_type: data.token_type }));
        localStorage.removeItem('authError');
        rememberAppSlug(appSlug);
        // Opening the invitation is the participant's explicit event entry action.
        // The course still requires consent before loading external media/tracking attendance.
        sessionStorage.setItem(`course-participate-${data.event_id}`, 'true');
        setLoginStatus(identity);
        history.replace(appPath(appSlug, `course/${data.event_id}`));
      } catch (err) {
        if (!active) return;
        setError(err.response?.status === 429
          ? 'Troppi tentativi di accesso. Attendi qualche minuto e riprova.'
          : 'Il link di accesso è scaduto oppure non è valido. Puoi accedere con email e password o richiedere un nuovo invito al gestore.');
      }
    }
    redeem();
    return () => { active = false; };
  }, [appSlug, history, location.pathname, setLoginStatus, token]);

  return <div className="login-page"><div className="login-card">
    <h1 className="login-title">Accesso al webinar</h1>
    {error ? <><Alert variant="warning">{error}</Alert>
      <Link to={appPath(appSlug, 'login')}>Accedi con email e password</Link></>
      : <div role="status"><Spinner animation="border" size="sm" aria-hidden="true" /> Accesso in corso...</div>}
  </div></div>;
}
